// src/templates/casestudy.tsx
import React, { useState } from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import {
  Box,
  Card,
  CardMedia,
  Container,
  IconButton,
  Pagination,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  Link,
} from "@mui/material"
import searchtopicIcon from "../images/newIcons/searchtopicIcon.svg"
import CloseIcon from "@mui/icons-material/Close"
import chatIcon from "../images/icons/chatIcon.svg"
import * as allImages from "../utils/images"
import Enquiry from "../components/enqiry"

const PressReleases: React.FC<any> = ({ pageContext }) => {
  const [value, setValue] = useState<string>("")
  const [filterdata, setFilterData] = useState<Array<object>>(pageContext[0])

  const [data, setData] = useState<any>(
    pageContext[0].sort((a: any, b: any) => {
      const dateA = new Date(a.date || 0).getTime()
      const dateB = new Date(b.date || 0).getTime()
      return dateB - dateA
    })
  )

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))

  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      setData(
        filterdata.filter(
          (ele: any) =>
            ele.title.toLowerCase().includes(e.target.value.toLowerCase()) ||
            ele.metaDescription
              .toLowerCase()
              .includes(e.target.value.toLowerCase())
        )
      )
    }
  }

  return (
    <Layout>
      <Seo
        title="Latest Press Releases & News"
        description="Stay updated with Invimatic's latest press releases, industry news, and company announcements. Explore how we’re shaping the future of secure SaaS enablement."
        keywords="Invimatic Press Releases"
      />
      <section>
        <div className="press-release-list-banner">
          <Stack
            className="headingHeroSection"
            alignItems="center"
            textAlign="center"
            sx={{ position: "relative", zIndex: 1, color: "#fff" }}
          >
            <Typography
              variant="h1"
              fontSize={isMobile ? 32 : 42}
              fontWeight={isMobile ? 600 : 700}
              ml={2}
              mr={2}
              mt="60px"
            >
              We build technology that gets noticed and talked about
            </Typography>
          </Stack>
        </div>
      </section>

      <section className=" casestudy-wrapper section-wrapper blogs-wrapper news-blog-wrapper">
        <Container className="mainWrapper" maxWidth="xl">
          <Stack
            direction="row"
            alignItems={isMobile ? "center" : "baseline"}
            justifyContent="space-between"
            pb={isMobile ? 2 : 0}
          >
            <TextField
              id="standard-basic"
              // label="Search Topic"
              variant="standard"
              placeholder="Search Topic"
              value={value}
              onKeyDown={handleKeyDown}
              onChange={e => setValue(e.target.value)}
              sx={{
                pb: isMobile ? 2 : 6,
                "& .MuiInputBase-input": { color: "#fff", width: 350 },
                "& .MuiFormLabel-root": { color: "#fff" },
                "& .MuiInput-underline:before": {
                  borderBottom: "1px solid #fff",
                },
                "& .MuiInput-underline:after": {
                  borderBottom: "1px solid #fff",
                },
                ".MuiInputBase-root:hover:not(.Mui-disabled, .Mui-error):before":
                  { borderBottom: "1px solid #fff" },
              }}
              InputProps={{
                startAdornment: (
                  <IconButton
                    sx={{ color: "#000", p: 0, mr: 1 }}
                    aria-label="search Topic"
                  >
                    <img src={searchtopicIcon} alt="search icon" />
                  </IconButton>
                ),

                endAdornment: (
                  <IconButton aria-label="clear search">
                    {value && (
                      <CloseIcon
                        sx={{ color: "#7B889F", p: 0, width: "18px" }}
                        onClick={() => {
                          setValue("")
                          setData(filterdata)
                        }}
                      />
                    )}
                  </IconButton>
                ),
              }}
            />
          </Stack>
          <div className="row">
            {data?.length ? (
              data?.map((ele: any) => (
                <div
                  key={ele.id}
                  className="col-lg-4 col-md-6 col-sm-12 col-12 custom-padding mb-4"
                >
                  <Link href={`/${ele.id}/`} underline="none">
                    <Card
                      sx={{
                        position: "relative",
                        width: "100%",
                        height: 300,
                        borderRadius: "10px",
                        border: "1px solid #d3e6ff",
                        boxShadow: "0px 10px 30px rgba(177, 202, 235, 0.6)",
                        transition: "all 0.3s ease-in-out !important",
                        background:
                          "linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(211,230,255,1) 100%)",
                        "&:hover": {
                          background:
                            "linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(230,241,255,1) 100%)",
                          "& .cardContent": {
                            padding: 0,
                          },
                          "& .cardMedia": {
                            display: "none",
                          },
                          "& .card-text": {
                            color: "white",
                            transform: "translateY(-56px)",
                            padding: "31.2px",
                          },
                          "& .read-more": {
                            display: "block",
                          },
                          "& .icon": {
                            filter: "invert(1)",
                          },
                          "& .hover-box": {
                            position: "absolute",
                            opacity: 1,
                            visibility: "visible",
                          },
                        },
                      }}
                    >
                      <Box className="cardContent">
                        <CardMedia
                          component="div"
                          className="cardMedia"
                          sx={{
                            position: "absolute",
                            width: "110px",
                            height: "130px",
                            top: 20,
                            right: 20,
                            borderRadius: "10px 10px 10px 90px",
                            backgroundImage: `url(${allImages[ele.image]})`,
                            backgroundPosition: "center",
                            backgroundSize: "cover",
                            display: "block",
                            transition: "transform 0.3s ease-in-out",
                          }}
                        />

                        <Stack
                          spacing={3.75}
                          className="card-text"
                          sx={{
                            position: "absolute",
                            top: 74,
                            p: 3.9,
                            transition: "transform 0.5s ease-in-out",
                            zIndex: 1,
                          }}
                        >
                          <Box
                            component="img"
                            src={allImages[ele.icon]}
                            className="icon"
                            sx={{
                              width: "50px",
                              height: "50px",
                            }}
                          />
                          <Typography
                            sx={{
                              fontSize: "18px",
                              fontWeight: 700,
                              marginTop: "15px !important",
                              lineHeight: "24px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              "-webkit-line-clamp": "4",
                              "-webkit-box-orient": "vertical",
                            }}
                            title={ele.title}
                          >
                            {ele.title}
                          </Typography>
                          <Typography
                            className="read-more"
                            sx={{
                              fontSize: "18px",
                              marginTop: "20px !important",
                              textDecoration: "underline",
                              display: "none",
                            }}
                          >
                            Read More...
                          </Typography>
                        </Stack>
                        <Box
                          component="img"
                          src={allImages[ele.hoverImage]}
                          alt="Image"
                          className="hover-box"
                          sx={{
                            borderRadius: "10px",
                            boxShadow: "0px 15px 40px rgba(177, 202, 235, 0.8)",
                            transition:
                              "opacity 0.5s ease-in-out, visibility 0.5s !important",
                            background: `url(${allImages[ele.hoverImage]})`,
                            backgroundSize: "cover",
                            width: "100%",
                            height: "auto",
                            opacity: 0,
                            visibility: "hidden",
                          }}
                        />
                      </Box>
                    </Card>
                  </Link>
                </div>
              ))
            ) : (
              <Stack textAlign="center" display="flex" width="100%" pt={6}>
                <Typography variant="h4" color="white">
                  Coming Soon...
                </Typography>
              </Stack>
            )}
          </div>

          {isMobile ? (
            <Stack
              direction="row"
              alignItems="center"
              textAlign="center"
              justifyContent="center"
              gap={2.5}
            >
              <Stack spacing={2}>
                <Pagination
                  count={3}
                  variant="outlined"
                  sx={{
                    ".MuiButtonBase-root": {
                      margin: "0 10px",
                      color: "#FAFAFC",
                      border: "1px solid  #FFF",
                      "&.Mui-selected": {
                        color: "#FAFAFC",
                        background: "#236CA5",
                      },
                    },
                  }}
                />
              </Stack>
            </Stack>
          ) : (
            <></>
          )}
        </Container>
      </section>

      <section
        className="discussYourProject"
        style={{
          borderTop: isMobile ? "1px solid rgb(181 181 181 / 50%)" : "unset",
        }}
      >
        <Container maxWidth="lg">
          <Stack
            sx={{
              position: "relative",
              zIndex: 1,
              pt: isMobile ? 0 : 5,
              pb: 0,
            }}
            direction={isMobile ? "column" : "row"}
            alignItems="center"
          >
            <Stack
              alignItems="center"
              gap={6}
              sx={{ width: isMobile ? "100%" : "50%" }}
            >
              <Stack alignItems="center" textAlign="center" gap={2}>
                {isMobile ? (
                  <></>
                ) : (
                  <img
                    src={chatIcon}
                    alt="Chat"
                    style={{ width: "auto !important" }}
                  />
                )}
                <Typography
                  variant="body1"
                  fontSize={isMobile ? 32 : 16}
                  fontWeight={isMobile ? 700 : 600}
                  color={isMobile ? "#fff" : "#C8DCFA"}
                  textAlign="center"
                >
                  Let's discuss your project
                </Typography>
                {isMobile ? (
                  <></>
                ) : (
                  <Typography
                    variant="h4"
                    color="#fff"
                    fontSize="20px"
                    fontWeight={700}
                    lineHeight="28px"
                    padding="0 30px"
                  >
                    Looking to scale your SaaS effortlessly? <br />
                    Share your project details, and we'll provide tailored
                    solutions to support the growth and security of your SaaS
                    business.
                  </Typography>
                )}
              </Stack>
            </Stack>
            <Box
              sx={{
                width: isMobile ? "100%" : "50%",
                marginTop: isMobile ? "20px" : "0px",
              }}
            >
              <Enquiry />
            </Box>
          </Stack>
        </Container>
      </section>
    </Layout>
  )
}

export default PressReleases
